import axios from "axios";
import Loading from "components/Loading";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQueryCustom } from "utils/useQueryCUstom";
import { useQueryParams } from "utils/useQueryParams";
import SelectInput, { SelectOption } from "./SelectInput";
import SelectInputWithDrag from "./SelectInputWithDrag";

interface SelectInputAsyncProps {
  name: string;
  label?: string;
  isMulti?: boolean;
  placeholder?: string;
  isRequired?: boolean;
  apiName: string;
  valueIsCode?: boolean;
  withDrag?: boolean;
  isDisable?: boolean;
  customError?: any;
  includeCode?: boolean;
  onChange?: (value: any) => void;
}

const SelectInputAsync: FC<SelectInputAsyncProps> = ({ valueIsCode, name, apiName, placeholder, isRequired, label, isMulti, withDrag, isDisable, customError, includeCode, onChange }) => {
  const { t } = useTranslation();
  const [mainData, setMainData] = useState<SelectOption[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

  const transformDataToSelectOptions = (dataArray: any): SelectOption[] => {
    return dataArray.map((data: any) => {
      const option: SelectOption = {
        value: valueIsCode ? (data?.code ? data.code : data._id) : data._id,
        label: apiName === "country-pairs" ? data?.slug : data?.name?.en || data?.name || data?.title?.en || data?.title || "No Label",
      };

      // Conditionally include the code if includeCode is true
      if (includeCode && data?.code) {
        option.code = data.code;
      }

      return option;
    });
  };

  const { data, isLoading, refetch } = useQueryCustom({
    name: `${name}_get`,
    url: () =>
      axios.get(`/admin/${apiName}`, {
        params: {
          // searchText: searchTerm, // Use the local search term
          limit: 30,
        },
      }),
    queryKey: [name], // Include searchTerm in queryKey
  });

  useEffect(() => {
    if (data?.data?.data?.result) {
      const editedData = transformDataToSelectOptions(data?.data?.data?.result);
      setMainData(editedData);
    }
  }, [data, valueIsCode, includeCode, apiName]);

  return withDrag ? (
    <SelectInputWithDrag
      name={name}
      options={mainData}
      isLoading={isLoading}
      // withSearch
      placeholder={isLoading ? <Loading size="w-4 h-4" /> : apiName === "languages" ? t("selectLanguage") : placeholder}
      searchFullSize
      isRequired={isRequired}
      label={label}
      isMulti={isMulti}
    />
  ) : (
    <SelectInput
      name={name}
      options={mainData}
      isLoading={isLoading}
      withSearch
      placeholder={isLoading ? <Loading size="w-4 h-4" /> : apiName === "languages" ? t("selectLanguage") : placeholder}
      searchFullSize
      isRequired={isRequired}
      label={label}
      isMulti={isMulti}
      isDisable={isDisable}
      customError={customError}
      onSearchChange={setSearchTerm}
      onChange={onChange}
    />
  );
};

export default SelectInputAsync;
